import axios from "axios";

export default {
    CONSTRUCTION_CAMERAS_API_URL: 'https://gis.msu.edu/server/rest/services/Hosted/Construction_Cameras_view/FeatureServer/0/query?where=1%3D1&outFields=projectno%2Cprojectname%2Curi%2Cprojecturi&returnGeometry=false&orderByFields=projectname&f=pjson',

    getConstructionCamers: function () {
        return axios.get(this.CONSTRUCTION_CAMERAS_API_URL).then(result => {
            return result.data.features.map(feature => feature.attributes)
        })
    }
}
